<template>
  <div class="about-page">
    <section class="banner">
      <h1>九恒智电</h1>
      <p>值得托付的一体化电碳服务</p>
    </section>
    <ul class="tab">
      <li :class="{c: curTab === 0}" @click="curTab = 0; scrolledTop = 0">关于九恒</li>
      <li :class="{c: curTab === 1}" @click="curTab = 1; scrolledTop = 0">社会责任</li>
      <li :class="{c: curTab === 2}" @click="curTab = 2; scrolledTop = 0">国际化</li>
      <li :class="{c: curTab === 3}" @click="curTab = 3; scrolledTop = 0">企业资质</li>
      <!-- <li :class="{c: curTab === 4}" @click="curTab = 4; scrolledTop = 0">合作伙伴</li> -->
    </ul>
    <div v-show="curTab === 0" class="tab-content">
      <div class="ctn">
        <h2>九恒智电</h2>
        <p>
          <img src="@/assets/a5.jpg"/>
          九恒智电专注于电能服务及运营近20年，是致力于为客户提供一体化电碳服务的全国领先品牌。公司主体北京九州恒盛电力科技是混合所有制企业，业务涵盖智电设计、智能配网、智慧运营、绿电低碳和智能产品五大板块，为国家级高新技术企业。<br/><br/>
          九恒智电秉承“技术引领”的发展思想，始终把建立高素质的技术人才队伍放在核心能力建设的首位。发展至今，公司汇集了一大批行业高级技术人才和管理人才。公司超过1/3员工拥有工程师资质，其中专业技术职称高、中级以上占比超过60%。<br/><br/>
          在一体化电碳业务中，公司已组建了一支打通智电全链条的专业技术队伍，具备智电设计规划、多元化实施能力，同时兼具软件研发、数据分析、电能管理评价、智能化运维的项目团队；基于智电运营生态，公司的碳业务由行业技术专家组成专家库，在新型电力系统解决方案和碳中和服务方面，为客户提供全价值链的精准服务。        </p>
        <h2>品牌精神</h2>
        <ul class="img-list">
          <li>
            <h3>专注</h3>
            <p>
              持续专注于智电行业+低碳领域<br/>
              深耕行业长达20年<br/>
              2018年即参与北京CCER自愿减排交易<br/>
              30+国内外专业高校合作，推动产学研一体化<br/>
              参与行业标准制定、推动行业转型发展
            </p>
          </li>
          <li>
            <h3>专业</h3>
            <p>
              打通“电+碳”生态全链条<br/>
              超过1/3员工拥有工程师资质<br/>
              业务部门电专业人员占比57%+<br/>
              专业技术职称高、中级以上占比60%+<br/>
              80项+专利软著、专业资质30项+<br/>
              参与国家发改委2022年双碳课题
            </p>
          </li>
          <li>
            <h3>值得托付</h3>
            <p>
              服务客户4000+<br/>
              客户合作平均年限＞5年<br/>
              客户好评率达到99.1%以上<br/>
              承接国家和北京市重大政治活动、标杆性项目<br/>
              实施众多政企军项目
            </p>
          </li>
        </ul>
      </div>
      <section class="big-bg" :class="scrolledTop >= 1330 && curTab === 0 ? 'scrolled' : ''">
        <h2 class="ctn">战略核心</h2>
        <p class="ctn">
          我国能源发展正经历百年巨变，推动双碳目标和经济发展结构绿色转型亦是百年大计。在九恒智电的战略蓝图中，我们将与国家、人们同呼吸、共命运——将建设电碳服务领域的知名品牌作为目标，以技术密集、人才密集作为公司持续运转的双引擎，以资本密集、资源密集作为“两翼”加速器，将引进国际先进技术与本土化结合作为爆发性突破的助燃剂。<br/><br/>
          战略目标及“3+1+1”战略保障让九恒智电不断创新创造，以生生不息、沛然不止的品牌之力，推动中国绿电低碳事业的蓬勃发展。
        </p>
      </section>
      <div class="ctn" v-loading="loading">
        <h2>大事记</h2>
        <!-- <img src="@/assets/a7.jpg"/> -->
        <ul class="history" :class="scrolledTop >= 2680 && curTab === 0 ? 'scrolled' : ''">
          <li v-for="(item, index) in events" :key="index">
            <h3>{{item.title}}</h3>
            <p>{{item.summary}}</p>
            <img v-if="item.thumb && item.thumb !== ''" :src="item.thumb"/>
          </li>

          <!-- <li>
            <h3>成立至2013年</h3>
            <p>公司主营智能配网服务</p>
            <img src="@/assets/a9.jpg"/>
          </li>
          <li>
            <h3>2014年</h3>
            <p>配网产品服务上线</p>
            <img src="@/assets/a10.jpg"/>
          </li>
          <li>
            <h3>2015年</h3>
            <p>运维服务开始孵化</p>
            <img src="@/assets/a11.jpg"/>
          </li>
          <li>
            <h3>2017年</h3>
            <p>公司拓展电力智能技术服务</p>
          </li>
          <li>
            <h3>2018年</h3>
            <p>智电规划设计服务纳入公司业务范畴，碳交易业务探索</p>
            <img src="@/assets/a12.jpg"/>
          </li>
          <li>
            <h3>2019年</h3>
            <p>公司新增绿色能源板块，布局碳规划与碳建设服务</p>
            <img src="@/assets/a13.jpg"/>
          </li>
          <li>
            <h3>2021年</h3>
            <p>公司业务梳理整合，形成五轮驱动的一体化电碳服务体系</p>
            <img src="@/assets/a14.jpg"/>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="tab-content tab2" :class="scrolledTop >= 0 && curTab === 1 ? 'scrolled' : ''">
      <div ref="img1" class="img" :class="scrolledTop >= 0 && curTab === 1 ? 'scrolled' : ''">
        <div class="bg" :style="`transform: translate3d(0px, ${positionY1}px, 0px);`"/>
        <p>
          九恒的发展战略响应国家绿色能源改革方向，得到了各级政府的认可与支持。2022年被北京市政府评为“专精特新小巨人”。<br/>
          在立足本土的同时，九恒兼具国际视野，积极拓展国际业务，目前已在国外多地建立分支机构，并与多个国家的能源机构及科研院校建立了长期合作关系。
        </p>
      </div>
      <div ref="img2" class="img" :class="scrolledTop >= 900 && curTab === 1 ? 'scrolled' : ''">
        <div class="bg" :style="`transform: translate3d(0px, ${positionY2}px, 0px);`"/>
        <h3>推动电力行业发展</h3>
        <p>九恒智电作为北京市电力行业协会副会长单位，多年来致力于推动电力行业发展。九恒与众多会员企业共同努力，不断提升总体技术服务水准，持续完善北京市电力行业市场规范。</p>
      </div>
      <div ref="img3" class="img" :class="scrolledTop >= 1400 && curTab === 1 ? 'scrolled' : ''">
        <div class="bg" :style="`transform: translate3d(0px, ${positionY3}px, 0px);`"/>
        <h3>为政府提供技术支持</h3>
        <p>
          为政府提供技术支持——2022年度，公司承研参与国家发改委碳达峰碳中和课题项目，旨在为双碳政策提供电力碳排放的相关数据支持。多年来，九恒推动并参与编制了包括北京市《配电室安全管理规范》在内的多个地方标准与行业标准的制定。<br/>
          <img src="@/assets/a2-5.png"/>
        </p>
      </div>
      <div ref="img4" class="img" :class="scrolledTop >= 2000 && curTab === 1 ? 'scrolled' : ''">
        <div class="bg" :style="`transform: translate3d(0px, ${positionY4}px, 0px);`"/>
        <h3>产学研一体化</h3>
        <p>九恒与行业、政府专家以及来自硅谷、伦敦、瑞士、德国等地的专家联合，与清华大学、华北电力大学、斯坦福大学、剑桥大学等国内外三十多家专业高校合作，推动实现产学研一体化，带动智电行业与低碳领域的技术革新。</p>
      </div>
    </div>
    <div v-show="curTab === 2" class="tab-content ctn" :class="scrolledTop >= 200 && curTab === 2 ? 'scrolled' : ''">
      <h2 class="center">国际化布局：境外业务分布</h2>
      <p class="center">“国际视野，立足本土”。公司积极开展国际合作，与英国、瑞士、德国、新加坡等国家的能源行业机构建立合作伙伴关系，致力于新技术、新产品的引进与研发，促进公司技术、产品和服务的不断升级，为客户持续创造价值。</p>
      <ul class="map">
        <li class="gwsz"><b>国网数智</b></li>
        <li class="bjlg"><b class="left">北京理工大学</b></li>
        <li class="bjjt"><b>北京交通大学</b></li>
        <li class="zgcm"><b>中国传媒大学</b></li>
        <li class="tshu"><b class="left">清华大学</b></li>
        <li class="gjkj"><b>国家科技部</b></li>
        <li class="gwkj"><b>国网科技部</b></li>
        <li class="hbeu"><b class="left middle">华北电力大学</b></li>
        <li class="gwny"><b class="bottom">国网综合能源公司</b></li>
        <li class="gwnr"><b class="bottom">国网南瑞</b></li>
        <li class="gem"><b class="top">德国专家智库</b></li>
        <li class="dglg"><b class="left middle">帝国理工学院</b></li>
        <li class="camb"><b class="left top">剑桥大学</b></li>
        <li class="siem"><b class="bottom">西门子</b></li>
        <li class="london"><b class="left bottom">英国专家智库</b></li>
        <li class="ldzz"><b>伦敦政治经济学院</b></li>
        <li class="sws"><b class="bottom">瑞士专家智库</b></li>
        <li class="snd"><b class="left bottom">施耐德</b></li>
        <li class="sgm"><b class="bottom">溯高美</b></li>
        <li class="colum"><b class="bottom">哥伦比亚大学</b></li>
        <li class="usa"><b class="left bottom">美国专家智库</b></li>
        <li class="silicon"><b>美国专家智库</b></li>
        <li class="stanf"><b class="left bottom">斯坦福大学</b></li>
      </ul>
    </div>
    <div class="tab-content ctn tab3" :class="scrolledTop >= 0 && curTab === 3 ? 'scrolled' : ''">
      <h2>企业资质</h2>
      <p class="endowment">
        <img src="@/assets/a4-1.jpg"/>
        <span>九恒智电深耕于电能领域近20年。在专业化方面，公司钻研智电设计、实施与运维的技术解决方案，至今已获得电能相关专业的全链条资质，其中包括电力设计、电力工程施工、输变电工程专业承包、售电资质等。</span>
      </p>
    </div>
    <div class="tab-content ctn partner" :class="scrolledTop >= 0 && curTab === 4 ? 'scrolled' : ''">
      <p class="tag"><b @click="go(400)">重大项目</b><b @click="go(1100)">学校</b><b @click="go(1580)">医院</b><b @click="go(2050)">园区&企业</b><b @click="go(2300)">数据中心</b></p>
      <ul>
        <li :class="scrolledTop >= 0 && curTab === 4 ? 'scrolled' : ''">
          <h3>重大项目</h3>
          <img src="@/assets/a5-1.jpg"/>
          <img src="@/assets/a5-2.jpg"/>
        </li>
        <li :class="scrolledTop >= 250 && curTab === 4 ? 'scrolled' : ''">
          <h3>学校</h3>
          <img src="@/assets/a5-3.jpg"/>
          <img src="@/assets/a5-4.jpg"/>
        </li>
        <li :class="scrolledTop >= 900 && curTab === 4 ? 'scrolled' : ''">
          <h3>医院</h3>
          <img src="@/assets/a5-5.jpg"/>
          <img src="@/assets/a5-6.jpg"/>
        </li>
        <li :class="scrolledTop >= 1300 && curTab === 4 ? 'scrolled' : ''">
          <h3>园区&企业</h3>
          <img src="@/assets/a5-7.jpg"/>
          <img src="@/assets/a5-8.jpg"/>
        </li>
        <li :class="scrolledTop >= 1700 && curTab === 4 ? 'scrolled' : ''">
          <h3>数据中心</h3>
          <img src="@/assets/a5-9.jpg"/>
          <img src="@/assets/a5-10.jpg"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curTab: 0,
      scrolledTop: 0,
      cleared: false,
      positionY1: 0,
      Y1: 0,
      positionY2: 0,
      Y2: 0,
      positionY3: 0,
      Y3: 0,
      positionY4: 0,
      Y4: 0,
      ratio: 0.01,
      events: [],
      loading: false
    }
  },
  // computed: {
  //   urlTab() {
  //     const tab =  this.$route.params.tab
  //     if (urlTab) this.curTab = Number(urlTab)
  //     return this.$route.params.tab
  //   }
  // },
  watch: {
    $route: {
      handler() {
        const tab =  this.$route.params.tab
        if (typeof tab !== 'undefined') {
          this.curTab = Number(tab)
        } else {
          this.curTab = 0
        }
      },
      deep: true
    },
    scrolledTop(n) {
      if (n > 200 && this.curTab === 2 && !this.cleared) {
        const vm = this
        setTimeout(function() {
          vm.cleared = true
        }, 8000)
      }
    },
    curTab() {
      this.cleared = false
    }
  },
  created() {
    const tab =  this.$route.params.tab
    if (tab) this.curTab = Number(tab)
    document.body.addEventListener('scroll', this.scrolling)
    this.getData()
  },
  mounted() {
    this.$nextTick(() => {
      this.Y1 = this.$refs.img1.offsetTop * this.ratio
      this.Y2 = this.$refs.img2.offsetTop * this.ratio
      this.Y3 = this.$refs.img3.offsetTop * this.ratio
      this.Y4 = this.$refs.img4.offsetTop * this.ratio
      console.log(this.Y1, this.Y2, this.Y3, this.Y4)
    })
  },
  methods: {
    getData(n) {
      this.loading = true;
      if (n) this.page = n
      axios.get(`/api/v1/article/list?page_size=20&page=1&ctype=7`).then(r => {
        this.total = r.data.count
        if (r && r.data && r.data.list) {
          this.events = r.data.list
          this.loading = false;
        }
      })
    },
    go(y) {
      document.body.scrollTo(0, y)
    },
    scrolling() {
      const s = document.body.scrollTop
      this.scrolledTop = s > this.scrolledTop ? s : this.scrolledTop
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // const w = document.body.clientWidth;
      // const offset = 200 - w * .18
      console.log(scrollTop)
      this.positionY1 = 0 - scrollTop * this.ratio;
      this.positionY2 = 0 - scrollTop * this.ratio;
      this.positionY3 = 0 - scrollTop * this.ratio;
      this.positionY4 = 0 - scrollTop * this.ratio;
    }
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrolling)
  }
}
</script>
